/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsisRuleFormDataTravelDateRestriction
 */
export interface OsisRuleFormDataTravelDateRestriction {
    /**
     * 
     * @type {object}
     * @memberof OsisRuleFormDataTravelDateRestriction
     */
    from?: object | null;
    /**
     * 
     * @type {object}
     * @memberof OsisRuleFormDataTravelDateRestriction
     */
    to?: object | null;
}

export function OsisRuleFormDataTravelDateRestrictionFromJSON(json: any): OsisRuleFormDataTravelDateRestriction {
    return OsisRuleFormDataTravelDateRestrictionFromJSONTyped(json, false);
}

export function OsisRuleFormDataTravelDateRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleFormDataTravelDateRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function OsisRuleFormDataTravelDateRestrictionToJSON(value?: OsisRuleFormDataTravelDateRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
    };
}


